export enum LevelType {
  CategoryWords = 'CategoryWords',
  KnownSentence = 'KnownSentence',
  WordSearch = 'WordSearch',
  WhatsInThePicture = 'WhatsInThePicture',
  WhereIsThisLocated = 'WhereIsThisLocated',
  WhatsTheSong = 'WhatsTheSong'
}

export interface WordPosition {
  word: string;
  startX: number;
  startY: number;
  direction: 'horizontal-reverse' | 'vertical' | 'vertical-up' | 'diagonal-down-left' | 'diagonal-up-left';
}

export interface WordSearchGrid {
  width: number;
  height: number;
  grid: string[][]; // 2D array of letters
  wordPositions: WordPosition[]; // Positions of words to find
}

export interface Level {
  id: string; // Document ID (numeric string like "1", "2", "3")
  levelType: LevelType;
  words?: string[]; // For CategoryWords only (deprecated for WordSearch)
  keyLetters?: string[]; // For all except WordSearch
  category?: string; // For CategoryWords and WordSearch
  difficulty: number;
  sentence?: string; // For KnownSentence, WhatsInThePicture, WhereIsThisLocated, WhatsTheSong
  locationName?: string; // For WhereIsThisLocated
  image?: string; // For picture-based levels
  imageSize?: number; // Size of the image in bytes
  solveCount?: number; // Number of times this level has been solved
  wordSearchGrid?: WordSearchGrid; // For WordSearch - new grid-based approach
  funFact?: string; // Optional fun fact to display after level completion
  lastModified?: number; // Unix timestamp (seconds) of last modification
}

export interface LevelFormData {
  levelNumber: string;
  levelType: LevelType;
  words: string[];
  keyLetters: string[];
  category: string;
  difficulty: number;
  sentence: string;
  locationName: string;
  image: string;
  imageSize?: number;
  wordSearchGrid?: WordSearchGrid;
  funFact: string;
}
